<template>
  <v-card>
    <v-card-title
      class="info white--text"
    >
      <v-layout
        justify-space-between
        align-center
      >
        <div class="subheading font-weight-medium">
          Recent Users
        </div>
        <v-btn
          icon
          :to="{ name: 'application.users' }"
        >
          <v-icon
            color="white"
          >
            open_in_new
          </v-icon>
        </v-btn>
      </v-layout>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list>
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="index"
            class="py-2"
          >
            <v-list-tile-content>
              <v-list-tile-title v-text="item.name" />
              <v-list-tile-sub-title v-text="item.email" />
            </v-list-tile-content>

            <v-list-tile-action>
              <v-chip
                dark
                :color="item.active ? 'success' : 'error'"
              >
                {{ item.active ? 'Active' : 'Inactive' }}
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider
            :key="item.email"
          />
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
